import { normalizePlatformFilters, defaultPlatformFilters, type PlatformFilters } from "@torre/expenses";

// Filtros de Pago de plataformas en la URL (?desde=2026-01&hasta=2026-09&cliente=wayak&pago=infraestructura&modelo=asiento…),
// para poder compartir una vista filtrada. Solo se escribe lo que difiere de los valores por defecto.

const URL_KEYS: Record<keyof PlatformFilters, string> = {
  from: "desde",
  to: "hasta",
  client: "cliente",
  category: "tipo",
  kind: "pago",
  model: "modelo",
  licensing: "licencia",
  status: "estado",
};

export function platformFiltersFromQuery(search: string, currentMonth: string): PlatformFilters {
  const q = new URLSearchParams(search);
  const raw: Partial<PlatformFilters> = {};
  for (const [k, param] of Object.entries(URL_KEYS) as [keyof PlatformFilters, string][]) {
    const v = q.get(param);
    if (v != null) (raw as Record<string, string>)[k] = v;
  }
  return normalizePlatformFilters(raw, currentMonth);
}

/**
 * Query string con solo lo que difiere de los valores por defecto; conserva
 * otros parámetros que ya tenga la URL.
 */
export function platformFiltersToQuery(f: PlatformFilters, currentMonth: string, existing = ""): string {
  const q = new URLSearchParams(existing);
  const def = defaultPlatformFilters(currentMonth);
  for (const [k, param] of Object.entries(URL_KEYS) as [keyof PlatformFilters, string][]) {
    if (f[k] && f[k] !== def[k]) q.set(param, String(f[k]));
    else q.delete(param);
  }
  const s = q.toString();
  return s ? `?${s}` : "";
}
